import React, {FC} from "react"
import {Row, Col} from "react-bootstrap"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import successImage from "@irati/ui/images/success.svg"
import {Body, H2} from "@irati/ui/src/Typography"

import {Img, Wrapper} from "./styled"

interface Props {
  message?: string,
  id?: string,
  withMarginTop?: boolean,
  hideSuccessImage?: boolean
}

const Success: FC<Props> = ({message, withMarginTop, hideSuccessImage, ...props}) => {
  const idNamespace = id("success", props)
  return (
    <Wrapper id={idNamespace} withMarginTop={withMarginTop}>
      <Row>
        <Col md={6} mdOffset={3}>
          {!hideSuccessImage && <Img id={id("img", idNamespace)} src={successImage} alt="Success" />}
          <H2 id={id("title", idNamespace)} marginBottom={1}>
            <FormattedMessage id="platform.successStep.success.title" />
          </H2>
          {message && (
            <Body id={id("copy-message", idNamespace)} marginBottom={5}>
              {message}
            </Body>
          )}
        </Col>
      </Row>
    </Wrapper>
  )
}

export default Success
